import { render, staticRenderFns } from "./default-grid.vue?vue&type=template&id=a0efd6d6&"
import script from "./default-grid.vue?vue&type=script&lang=ts&"
export * from "./default-grid.vue?vue&type=script&lang=ts&"
import style0 from "./default-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports